module.exports = __webpack_public_path__ + "img/TechGatherGold3_ua.6126a918.webp";